var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',_vm._b({staticStyle:{"min-width":"150px"},attrs:{"disabled":_vm.disabled || _vm.innerDisabled,"type":"primary"},on:{"click":_vm.sendCode}},'el-button',_vm.$attrs,false),[_vm._v("\n  "+_vm._s(_vm.text)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }